import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultServerUrls } from '../defaultServerUrls';
import { getEnvironmentOverride } from '../environmentOverride';
import { Urls } from './types';

const builtEnvironment = getEnvironmentOverride() ?? process.env.APP_ENV!;

export interface EnvironmentState {
  readonly activeEnvironment: string;
  readonly urls: Urls | undefined;
}

const initialState: EnvironmentState = {
  activeEnvironment: builtEnvironment,
  urls: Object.keys(defaultServerUrls).includes(builtEnvironment) ? defaultServerUrls[builtEnvironment] : undefined,
};

console.log(`activeEnvironment: ${initialState.activeEnvironment}`);
if (initialState.urls) {
  for (const [urlName, url] of Object.entries(initialState.urls)) {
    console.log(`${urlName}: ${url}`);
  }
}

const environmentSlice = createSlice({
  name: 'environment',
  initialState,
  reducers: {
    setEnvironmentFromKey: (state, action: PayloadAction<string>) => {
      state.activeEnvironment = action.payload;
      state.urls = defaultServerUrls[action.payload];
    },
  },
});

export const { setEnvironmentFromKey } = environmentSlice.actions;
export const environment = environmentSlice.reducer;

export interface StateWithEnvironment {
  readonly environment: EnvironmentState;
}
